module.exports = __webpack_public_path__ + "img/rosa_ventos.23f6e54c.png";